import React from 'react';
import { useAppState } from '../hooks/useAppState';
import OnboardingPage from '../pages/OnboardingPage';
import GeneratePage from '../pages/GeneratePage';
import RouteResultsPage from '../pages/RouteResultsPage';
import NavigationMode from '../pages/NavigationMode';
import { LocationInput } from '../types';

interface AppRouterProps {
  currentPage: 'generate' | 'route-results' | 'navigation';
  routeData: {
    startLocation: LocationInput;
    endLocation: LocationInput;
    routeCoordinates?: [number, number][];
    requestId?: number;
    routeStats?: {
      total_distance?: number;
      total_crossings?: number;
      distance_sidewalk?: number;
      distance_bikelane?: number;
      total_duration?: number;
      time_sidewalk?: number;
      time_bikelane?: number;
    };
  } | null;
  onRouteGenerated: (
    startLocation: LocationInput,
    endLocation: LocationInput,
    routeCoordinates?: [number, number][],
    requestId?: number,
    routeStats?: {
      total_distance?: number;
      total_crossings?: number;
      distance_sidewalk?: number;
      distance_bikelane?: number;
      total_duration?: number;
      time_sidewalk?: number;
      time_bikelane?: number;
    }
  ) => void;
  onBackToGenerate: () => void;
  onStartNavigation: (routeCoordinates: [number, number][]) => void;
  onStopNavigation: () => void;
  onBackFromNavigation: () => void;
  onRouteCompleted: () => void;
  onBackToOnboarding: () => void;
}

const AppRouter: React.FC<AppRouterProps> = ({
  currentPage,
  routeData,
  onRouteGenerated,
  onBackToGenerate,
  onStartNavigation,
  onStopNavigation,
  onBackFromNavigation,
  onRouteCompleted,
  onBackToOnboarding
}) => {
  const { state } = useAppState();

  // Show onboarding page if user hasn't completed initial onboarding
  if (!state.userPreferences.hasCompletedOnboarding) {
    return <OnboardingPage onComplete={() => {}} />;
  }


  // Show route results page if route data is available
  if (currentPage === 'route-results' && routeData) {
    return (
      <RouteResultsPage
        startLocation={routeData.startLocation}
        endLocation={routeData.endLocation}
        routeCoordinates={routeData.routeCoordinates}
        requestId={routeData.requestId}
        routeStats={routeData.routeStats}
        onBack={onBackToGenerate}
        onStartRoute={onStartNavigation}
      />
    );
  }

  // Show navigation mode if currently navigating
  if (currentPage === 'navigation' && routeData) {
    return (
      <NavigationMode
        startLocation={routeData.startLocation}
        endLocation={routeData.endLocation}
        routeCoordinates={routeData.routeCoordinates || []}
        requestId={routeData.requestId}
        onBack={onBackFromNavigation}
        onStopNavigation={onStopNavigation}
        onRouteCompleted={onRouteCompleted}
      />
    );
  }

  // Show generate page
  return (
    <GeneratePage 
      onRouteGenerated={onRouteGenerated}
      onBackToOnboarding={onBackToOnboarding}
    />
  );
};

export default AppRouter;
